"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileNavItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const useLinkWithWcid_1 = __importDefault(require("../../../hooks/useLinkWithWcid"));
const MobileNavItem_module_css_1 = __importDefault(require("./MobileNavItem.module.css"));
/**
 *
 */
function MobileNavItem(props) {
    const { item, active } = props;
    const { label, title, link, Icon, openInNewTab } = item;
    const href = (0, useLinkWithWcid_1.default)(link);
    return ((0, jsx_runtime_1.jsx)("a", { href: href, "aria-label": label, className: (0, clsx_1.default)(MobileNavItem_module_css_1.default.link, { [MobileNavItem_module_css_1.default.activeLink]: active }), onClick: (event) => props.onClick(event, item), target: openInNewTab ? "_blank" : "", rel: "noopener", children: (0, jsx_runtime_1.jsxs)("span", { className: MobileNavItem_module_css_1.default.content, children: [(0, jsx_runtime_1.jsx)("span", { className: MobileNavItem_module_css_1.default.icon, children: (0, jsx_runtime_1.jsx)(Icon, { active: active }) }), (0, jsx_runtime_1.jsx)("span", { className: MobileNavItem_module_css_1.default.text, children: title })] }) }));
}
exports.MobileNavItem = MobileNavItem;
//# sourceMappingURL=MobileNavItem.js.map